import React from "react";

import { Grid } from "@mui/material";

const CardDataPoint = ({ label, value, isLoading = false }) => {
  let valueString = null;
  if (Array.isArray(value)) {
    valueString = (
      <div>
        {value.map((val, index) => {
          return <div key={index}>{val}</div>;
        })}
      </div>
    );
  } else {
    valueString = value;
  }

  return (
    <Grid container spacing={2} maxWidth padding={2}>
      {label !== "" && (
        <Grid item xs={6}>
          <b>{label}</b>
        </Grid>
      )}
      <Grid item xs={label == "" ? 12 : 6}>
        {!isLoading ? (
          value ? (
            valueString
          ) : (
            <div className="card-data-point-strike" />
          )
        ) : null}
      </Grid>
    </Grid>
  );
};

export default CardDataPoint;
